import { useQuery } from '@tanstack/react-query';

import getStockList from 'Api/stock-promo/getStockList';

import getStockListResponse from './model/response/getStockListResponse';

import getStockListRequest from './model/request/getStockListRequest';

const useGetStockList = ({ params, enabled }) => {
  return useQuery({
    queryKey: ['stock-list', params],
    queryFn: async () => {
      const queries = getStockListRequest(params);
      
      const response = await getStockList(queries);

      return getStockListResponse(response.data);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetStockList;
